import { render, staticRenderFns } from "./UserJourney.vue?vue&type=template&id=050b9642&scoped=true&lang=pug&"
import script from "./UserJourney.vue?vue&type=script&lang=js&"
export * from "./UserJourney.vue?vue&type=script&lang=js&"
import style0 from "./UserJourney.vue?vue&type=style&index=0&id=050b9642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b9642",
  null
  
)

export default component.exports